import BaseService from '@/scripts/services/base/base.service'

export default class GeneralService extends BaseService {
    constructor() {
        super('General')
    }

    saveContactUs(contactUs) {
        return this.postRequest('SaveContactUs', contactUs, false)
    }

    listAllStates() {
        return this.getRequest('ListAllStates')
    }

    listAllEmailFrequencyPeriod() {
        return this.getRequest('ListAllEmailFrequencyOptions')
    }

    listAllIncentiveLaws() {
        return this.getRequest('ListAllIncentiveLaws')
    }
}
